import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'

import { 
	openModal, 
	logoutUser,
	openHeaderTab,
	resetInstructions
} from 'state/actions'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import PopMenu from './pop-menu'

import { 
	doClickEventListeners,
	getBaseSlugFromPath,
	isMobile
} from 'utils'

class HeaderControls extends Component {
	componentWillMount(){
		doClickEventListeners(this.handleClick)
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClick, true)
    }

	handleClick = e => {
		if(this.ref && !this.ref.contains(e.target) && this.props.isMenuOpen){
			this.props.toggleMenu(false)
		}
	}

	openSection = slug => {
		const {
			location,
			history,
			openHeaderTab
		} = this.props

		const baseSlug = getBaseSlugFromPath(location.pathname)

		history.push(baseSlug+'/'+slug)

		setTimeout(_ => {
			openHeaderTab(null)
		},2)

	}

	resetInstructions = _ => {
		const {
			resetInstructions,
			userData
		} = this.props

		resetInstructions(userData)
	}

	render() {
		const { 
			userData, 
			isMenuOpen, 
			toggleMenu,
			currentAccount,
			openModal,
			logoutUser,
			amAdmin,
		} = this.props 

		this.menuOptions = [
			{
				label: 'My profile',
				icon: "user-circle-o",
				callback: _ => {
					openModal('edit', 'settings', {
						type: 'user',
					})
				}
			},
			{
				label: "My organizations",
				icon: "fe-shuffle",
				callback: _ => {
					openModal('swap','organisation', null)
				}
			},
			{
				label: 'Support & training',
				icon: "fe-clipboard",
				callback: _ => {
					window.open('https://hassl.co/how-tos','_blank')
				}
			},
			{
				label: 'Log out',
				icon: "fe-log-out",
				callback: logoutUser
			}
		]

		if(!userData.prevent_new_onboarding || currentAccount.isPremium){
			this.menuOptions.splice(2, 0, {
				label: "Reset instructions",
				icon: "fe-help-circle",
				callback: this.resetInstructions
			})
		}

		if(currentAccount.isPremium){
			this.menuOptions.splice(2, 0, {
				label: "Get started with Hassl",
				icon: 'fe-refresh-cw',
				callback: _ => {
					openModal('welcome', 'business')
				}
			})
		}

		if(amAdmin){
			this.menuOptions.splice(1, 0, {
				label: currentAccount.name,
				icon: "building-o",
				callback:  _ => {
					this.openSection('status')
				}
			})
		}

		if(isMobile()){
			this.menuOptions.splice(1, 0, {
				label: 'People',
				icon: "fe-users",
				callback: _ => {
					this.openSection('people')
				}
			})

		}

		return (
			<div className="header-menu" ref={e => this.ref = e}>
				<a onClick={_ => {toggleMenu()}} className={isMenuOpen ? 'open' : null}>
					<ProfilePicture user={userData} isTiny={true} /> 
					<span>
						{ userData.first_name+' '+userData.last_name }
					</span>
				</a>
				<PopMenu 
					currentAccount={currentAccount} 
					userData={userData} 
					closeMenu={_ => {toggleMenu(false)}} 
					isOpen={isMenuOpen} 
					options={this.menuOptions} 
				/>
			</div>
		);
	}
}

export default withRouter(connect(null, { 
	openModal, 
	logoutUser,
	openHeaderTab,
	resetInstructions
})(HeaderControls))


// WEBPACK FOOTER //
// ./src/layout/header/header-controls.jsx